/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DirectoryContact
 */
export interface DirectoryContact {
    /**
     * 
     * @type {string}
     * @memberof DirectoryContact
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DirectoryContact
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DirectoryContact
     */
    position?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectoryContact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectoryContact
     */
    phone?: string;
}

/**
 * Check if a given object implements the DirectoryContact interface.
 */
export function instanceOfDirectoryContact(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DirectoryContactFromJSON(json: any): DirectoryContact {
    return DirectoryContactFromJSONTyped(json, false);
}

export function DirectoryContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectoryContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function DirectoryContactToJSON(value?: DirectoryContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'position': value.position,
        'email': value.email,
        'phone': value.phone,
    };
}

